import { defineStore } from 'pinia';
import stores from '@/stores';
import { delay } from '🔗/utils/utils';

export const createMaxMessenger = () =>
    defineStore('max-messenger', {
        state: () => ({
            base: 'https://max.ru/id481104453552_bot?startapp='
        }),
        actions: {
            // Проверка возможности логина (аналог Telegram)
            canLogin() {
                return true;//!!window.WebApp?.initDataUnsafe?.user?.username;
            },
            
            async getLoginData() {
                // Ожидание инициализации объекта MAX
                if (!window.WebApp) {
                    await delay(1500);
                }

                const initData = this.getInitData();
                const ref = this.getRef();

                return {
                    initData,
                    ref
                };
            },

            async init() {
                if (!window.WebApp) {
                    return;
                }

                const max = window.WebApp;
                
                max.ready(); 

                if (max.disableVerticalSwipes) {
                    max.disableVerticalSwipes()
                }

                const platform = max.platform; // ios, android, windows, macos, linux
                const isMobile = platform === 'ios' || platform === 'android' || platform === 'unknown' || !platform;
                const isDesktop = !isMobile;

                if (isMobile) {
                    try {
                        max.expand?.(); 
                    } catch (e) {}

                    if (max.requestFullscreen) {
                        max.requestFullscreen();
                    }

                    // Запросить подтверждение закрытия
                    if (max.enableClosingConfirmation) {
                        max.enableClosingConfirmation()
                    }
                }

                if (isDesktop) {
                    document.body.classList.add('desktop-miniapp');
                }

                this.locale = max.initDataUnsafe?.user?.language_code;

                this.theme = max.colorScheme;

                this.updateMsgrColors();
            },

            share({ url, message }) {
                if (window.WebApp?.shareContent) {
                    window.WebApp.shareContent({
                        link: url,
                        text: message
                    });
                }
            },

            updateMsgrColors() {
                const max = window.WebApp;
                if (!max) {
                    return;
                }

                const color = stores.others().theme === 'light' ? '#ffffff' : '#121212';
                
                try {
                    max.setHeaderColor?.(color);
                    max.setBackgroundColor?.(color);
                } catch (e) {}
            },

            getInitData() {
                return window.WebApp?.initData;
            },
            getDefaultProfileImage() {
                if (!window.WebApp.initDataUnsafe?.user?.photo_url) {
                    return;
                }

                return {
                    resized: window.WebApp.initDataUnsafe.user.photo_url,
                    original: window.WebApp.initDataUnsafe.user.photo_url
                }
            },

            getStartParam() {
                return window.WebApp?.initDataUnsafe?.start_param;
            },

            getRef() {
                let ref = null;
                const startParam = this.getStartParam() || '';
                
                startParam.split('&').forEach(item => {
                    if (item.toLowerCase().includes('ref_')) {
                        ref = item.toLowerCase().split('ref_')[1];
                    }
                });

                return ref;
            },

            openLink({ external_url, type, target }) {
                const max = window.WebApp;
                if (max) {
                    // Для внутренних ссылок MAX используется openMaxLink
                    if (type === 'max' || external_url.includes('max.ru')) {
                        max.openMaxLink(external_url);
                    } else {
                        if (target) {
                            window.open(external_url, target);
                        } else {
                            max.openLink(external_url);
                        }
                    }
                } else {
                    window.open(external_url, '_blank');
                }
            },

            showBackButton(back) {
                const button = window.WebApp?.BackButton;
                if (!button) {
                    return;
                }

                button.show();
                window.WebApp.BackButton.onClick(back);
            },
            hideBackButton(back) {
                const button = window.WebApp?.BackButton;
                if (!button) {
                    return;
                }

                window.WebApp.BackButton.offClick(back);
                button.hide();
            },

            showSettingsButton(callback) {
            },
            hideSettingsButton(callback) {
            },

            vibrate(mode) {
                const hf = window.WebApp?.HapticFeedback;

                if (!hf) {
                    return;
                }

                // Поддерживаемые стили: soft, light, medium, heavy, rigid
                if (['success', 'warning', 'error'].indexOf(mode) !== -1) {
                    hf.notificationOccurred(mode);
                    return;
                }

                hf.impactOccurred(mode || 'light');
            }
        }
    });